var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFfCreditCardDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 48,
    viewBox: "0 0 77 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credit Card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 17.3925V40.3746C0 44.5859 3.55986 48.0062 7.93989 48.0004L68.2598 47.9887C72.6398 47.9887 76.1939 44.5685 76.1939 40.3571V17.3867H0V17.3925ZM65.9971 39.7173C66.032 40.4444 66.0669 41.0203 66.1425 41.6427H62.2627C62.3325 41.0203 62.3907 40.4444 62.4081 39.6998C59.2147 39.4032 58.1852 38.3096 58.1852 36.3319C58.1852 36.0353 58.2026 35.7444 58.2375 35.4129C58.8308 35.4652 59.6975 35.5176 60.5642 35.5176C61.1575 35.5176 61.681 35.5176 62.0998 35.4827V35.727C62.0998 36.7507 62.5884 37.1521 64.1939 37.1521C65.7993 37.1521 66.2356 36.7507 66.2356 36.0935C66.2356 35.314 65.7819 34.8079 63.3679 34.4822C59.238 33.9471 58.2259 32.6267 58.2259 30.3174C58.2259 28.2699 59.4532 27.0891 62.4139 26.7634C62.3965 26.0014 62.3441 25.408 62.2685 24.7682H66.1483C66.096 25.3906 66.0378 25.9839 66.0029 26.7284C69.2312 26.9553 70.2608 27.8744 70.2608 30.0964C70.2608 30.3407 70.2433 30.5966 70.2259 30.8933C69.6849 30.8409 68.8008 30.806 68.0271 30.806C67.4164 30.806 66.8172 30.8235 66.4391 30.8409C66.4566 30.7188 66.4566 30.5966 66.4566 30.4919C66.4566 29.5729 65.9331 29.2762 64.3451 29.2762C62.8851 29.2762 62.4663 29.6601 62.4663 30.2301C62.4663 30.9049 62.792 31.4284 65.4445 31.8065C69.144 32.3416 70.4411 33.4701 70.4411 35.9713C70.4411 38.1061 69.2661 39.4265 66.0029 39.7173H65.9971Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M76.1939 12.634V7.62579C76.1939 3.41445 72.6398 -0.00580936 68.254 7.40836e-06L7.93407 0.0116412C3.55405 0.0116412 0 3.4319 0 7.64324V12.6399H76.1939V12.634Z",
    fill: "#919191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfCreditCardDisabled);
export default __webpack_public_path__ + "static/media/FFCreditCardDisabled.66106e0c2d2f1e57e47cbe7af97eade5.svg";
export { ForwardRef as ReactComponent };